import { useTranslation } from "react-i18next";
import { dienstenImages } from "@/mocks/dienstenImages";

export default function Diensten() {
  const { t } = useTranslation("home");
  const items = t("diensten.items", { returnObjects: true }) as Array<{
    title: string;
    desc: string;
    price: string;
    link: string;
  }>;

  return (
    <section id="diensten" className="bg-brand-cream py-20 md:py-[120px] w-full">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-geist font-bold text-3xl md:text-[48px] text-brand-text mb-12 md:mb-20">
          {t("diensten.h2")}
        </h2>

        <div className="flex flex-col gap-12 md:gap-16">
          {items.map((item, i) => {
            const isEven = i % 2 === 1;
            return (
              <div
                key={item.title}
                className={`flex flex-col ${
                  isEven ? "lg:flex-row-reverse" : "lg:flex-row"
                } items-center rounded-3xl bg-white p-4 md:p-6 lg:p-8 gap-6 md:gap-8`}
              >
                <div className="w-full lg:w-1/2 h-80 rounded-2xl overflow-hidden flex-shrink-0">
                  <img
                    src={dienstenImages[i]}
                    alt={`${item.title} — kozijnservice Eindhoven`}
                    className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="w-full lg:w-1/2 flex flex-col justify-center">
                  <h3 className="font-geist font-bold text-2xl md:text-[32px] text-brand-text mb-4">
                    {item.title}
                  </h3>
                  <p className="font-geist text-base md:text-lg text-brand-text/70 leading-relaxed mb-6">
                    {item.desc}
                  </p>
                  <p className="font-geist-mono text-xl md:text-2xl text-brand-yellow mb-4">
                    {item.price}
                  </p>
                  <a
                    href={item.link}
                    className="font-geist font-bold text-sm text-brand-text underline underline-offset-4 hover:text-brand-blue transition-colors inline-flex items-center gap-1 w-fit"
                  >
                    Meer
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center text-sm"></i>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}